import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import PageLayout from "../../PageLayout/PageLayout";
import classes from "./Location.module.css";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import {
  AddIconBlue,
  AddIconGray,
  EditIconGray,
  ImageWithLocationIcon,
  TrashIconGray,
} from "../../../../../constant/imagePath";
import { Button } from "../../../../../stories/Button/Button";
import { Input } from "../../../../../stories/Input/Input";
import LocationInput from "../../../../../stories/LocationInput/LocationInput";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import LocationMobile from "./LocationMobile";
import AddedLocationCard from "../../../../../stories/AddedLocationCard/AddedLocationCard";
import { useDispatch, useSelector } from "react-redux";
import Maps from "../../../../../components/Maps";
import { setPersonalData } from "../../../../../store/Actions/authAction";
import { setActiveTab } from "../../../../../store/Actions/commonAction";
import { useLocation } from "react-router";

const LocationDesktop = () => {
  const dispatch = useDispatch();
  const getDataFromRedux = useSelector(
    (state) => state.onBoardingReducer.address
  );

  const [venueName, setVenueName] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState(null);
  const [state, setState] = useState(null);
  const [zipcode, setZipcode] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState("");
  const [locationDetail, setLocationDetail] = useState({});
  const [coordinate, setCoordinate] = useState({});

  const [locations, setLocations] = useState(
    getDataFromRedux ? getDataFromRedux : []
  );

  // Edit Location
  const editLocation = (item) => {
    console.log("edd", item);
    setIsEditing(true);
    setEditingId(item?._id);
    setVenueName(item?.venueName);
    setAddress(item?.address);
  };

  // Delete Location
  const deleteLocation = (id) => {
    const newArr = locations.filter((item) => item._id !== id);
    setLocations(newArr);
  };

  // add location
  const addlocation = () => {
    if (isEditing) {
      const _locations = [...locations];
      const index = _locations.findIndex((data) => data._id == editingId);
      const updatedDoc = {
        _id: editingId,
        venueName,
        img: ImageWithLocationIcon,
        ...locationDetail,
      };
      _locations?.splice(index, index + 1, updatedDoc);

      setLocations(_locations);
      setIsEditing(false);
      setEditingId("");
    } else {
      const newDoc = {
        _id: Math.floor(Math.random() * 10000),
        venueName,
        address,
        img: ImageWithLocationIcon,
        ...locationDetail,
      };
      setLocations((p) => [...p, newDoc]);
    }

    setVenueName("");
    setAddress("");
  };
  function saveDataIntoRedux() {
    dispatch(setPersonalData("address", locations));
  }

  console.log({ locations });
  return (
    <div className={[classes.LocationScreen].join(" ")}>
      <Container fluid className={[classes.container, "p-0"].join(" ")}>
        <Row className={[classes.mb52, "g-0"].join(" ")}>
          <Col md={12}>
            <div className={`${classes.edit_heading_main_div}`}>
              <div>
                <h3
                  style={{
                    ...Fonts.h3,
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Edit Lesson Info
                </h3>
              </div>
              <div className={`${classes.edit_heading_button_div}`}>
                <Button
                  primary={false}
                  size="Medium"
                  customStyle={{
                    padding: "14px 24px",
                    width: "max-content",
                    marginRight: "12px",
                    ...Fonts.b2,
                  }}
                >
                  Profile preview
                </Button>
                <Button
                  primary={true}
                  size="Medium"
                  customStyle={{
                    padding: "14px 24px",
                    width: "max-content",
                    ...Fonts.b2,
                  }}
                  onClick={saveDataIntoRedux}
                >
                  Save changes
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        <Row className={`g-0 ${classes.row}`}>
          <Col md={12} className={classes.mt52}>
            {locations?.map((item, i) => {
              return (
                <AddedLocationCard
                  data={item}
                  onDelete={deleteLocation}
                  onEdit={editLocation}
                />
              );
            })}
          </Col>

          <Col md={12} className={`${[classes.mb32].join(" ")}`}>
            <Input
              label={"Venue Name (Optional)"}
              state={venueName}
              setter={setVenueName}
              placeholder=""
            />
          </Col>
          <Col md={12} className={`${[classes.mb32].join(" ")}`}>
            <Maps
              type={"places"}
              label={"Address"}
              setAddress={setAddress}
              placeholder={"Type here.."}
              setCoordinates={setCoordinate}
              setPlaceDetail={setLocationDetail}
            />
          </Col>

          <Col md={12} className={`${[classes.mb32].join(" ")}`}>
            <LinkButtonWithIcon
              leftIcon={AddIconBlue}
              text={"Add another place"}
              customStyle={{
                ...Fonts.b2,
                fontSize: "14px",
                lineHeight: "20px",
              }}
              iconStyle={{
                marginRight: "10px",
                width: "16px",
                height: "16px",
              }}
              onClick={addlocation}
              primary={true}
              disabled={address == "" ? true : false}
            />
          </Col>
        </Row>
      </Container >
    </div >
  );
};

const Location = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <LocationMobile /> : <LocationDesktop />;
};

export default Location;
